
class redInfoCtrl {
    constructor($rootScope, $scope, httpRequest, operationService) {
        // 用户信息
        $scope.userInfo = $rootScope.userInfo
        // 页面缓存信息
        $scope.pageState = {
            idToken: $rootScope.idToken,
            limitNumber: 2000,
            isFlowIsValid: false,
            hasUploadPermit: false,
            ifShowSubmitBtn: false, // 是否显示提交按钮
        }

        // 是否启用审核流
        httpRequest.post_qryFlowIsValid({ approveCode: 'red_info_approve' }).then((res) => {
            // 开启审批流
            $scope.pageState.isFlowIsValid = res.data.value
            // 是否有上传权限
            $scope.pageState.hasUploadPermit = operationService.hasPermit('upload_tax_z')

            if ($scope.pageState.isFlowIsValid) {
                $scope.pageState.ifShowSubmitBtn = true
            } else if ($scope.pageState.hasUploadPermit) {
                $scope.pageState.ifShowSubmitBtn = false
            } else {
                $scope.pageState.ifShowSubmitBtn = true
            }
        })

        // 字典
        $scope.dictData = {}
        const typecodeArrStr = '["red_info_applicant","red_info_status","red_info_workflow_status","is_pass","inv_type","approve_status","bill_status","invoice_nature","tax_includ","is_privilege","zero_tax","is_list","invoice_status","yes_no_flag","red_info_source","red_invoice_status"]'
        const typecodeArr = ['red_info_applicant', 'red_info_status', 'red_info_workflow_status', 'is_pass', 'inv_type', 'approve_status', 'bill_status', 'invoice_nature', 'tax_includ', 'is_privilege', 'zero_tax', 'is_list', 'invoice_status', 'yes_no_flag', 'red_info_source', 'red_invoice_status']
        httpRequest.get_dictByTypeArr(typecodeArrStr).then((res) => {
            $scope.dictData = res.data.value
            for (let i = 0, l = typecodeArr.length; i < l; i++) {
                const arr = $scope.dictData[typecodeArr[i]]
                arr.push({ enumTypeCode: null, enumName: '全部', enumCode: '' })
                arr.reverse()
                $scope.dictData[typecodeArr[i]] = arr
            }
            // 新增和编辑页面的申请人
            $scope.dictData.red_info_applicantinfo = $scope.dictData.red_info_applicant.slice(1)
        })
        // 商品行阈值
        httpRequest.get_getLimitNumber().then((res) => {
            if (res.data.success) {
                $scope.pageState.limitNumber = res.data.value
            }
        })
    }
}

redInfoCtrl.$inject = ['$rootScope', '$scope', 'httpRequest', 'operationService']
export default redInfoCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/redWordInfo/redInfoCtrl.js